'use strict';
require('./vendor');

jQuery(document).ready(function($) {

  $('#hamburger').click(function() {
    $(this).toggleClass('active');
    $('#mb-nav').toggleClass('active');
    $('body').toggleClass('overflow');
  });

  $('#email-placeholder').change(function() {
    $('#nieuwsbrief #user-email').val($(this).val());
  });

  $('#mb-nav a').click(function() {
    $('body').removeClass('overflow');
    $('#mb-nav').removeClass('active');
    $('#hamburger').removeClass('active');
  });

  $('.popup-with-form').magnificPopup({
    type: 'inline',
    preloader: false,
    focus: '#firstname',

    // When elemened is focused, some mobile browsers in some cases zoom in
    // It looks not nice, so we disable it:
    callbacks: {
      beforeOpen: function() {
        if ($(window).width() < 700) {
          this.st.focus = false;
        } else {
          this.st.focus = '#firstname';
        }
      }
    }
  });
});

$(document).foundation();

if (module.hot) {
  module.hot.accept()
}
